import React, { useState, useRef, useEffect } from 'react'
import { createPortal } from 'react-dom'
import { Box } from '@mui/joy'
import { ChromePicker } from 'react-color'
import InputTextElement from './InputTextElement'

const InputColorPicker = ({ editing, required, name, label, autoFocus, placeholder, hint, haserror, disabled, readonly, className = "", value, onChange, error }) => {
	const [pickerVisible, setPickerVisible] = useState(false)
	const [pickerPosition, setPickerPosition] = useState({ top: 0, left: 0 })
	const containerRef = useRef(null)
	const colorButtonRef = useRef(null)
	const pickerRef = useRef(null)

	useEffect(() => {
		function handleClickOutside(event) {
			if (
				containerRef.current &&
				!containerRef.current.contains(event.target) &&
				(!pickerRef.current || !pickerRef.current.contains(event.target))
			) {
				setPickerVisible(false)
			}
		}
		document.addEventListener("mousedown", handleClickOutside)
		return () => document.removeEventListener("mousedown", handleClickOutside)
	}, [])

	useEffect(() => {
		if (pickerVisible && colorButtonRef.current) {
			const buttonRect = colorButtonRef.current.getBoundingClientRect()
			const { innerHeight, innerWidth } = window
			const pickerHeight = 220
			const pickerWidth = 225
			let top = buttonRect.bottom + 8
			let left = buttonRect.left
			if (top + pickerHeight > innerHeight) top = buttonRect.top - pickerHeight - 8
			if (left + pickerWidth > innerWidth) left = innerWidth - pickerWidth - 8
			setPickerPosition({ top, left })
		}
	}, [pickerVisible])

	if (!editing) readonly = true

	const displayValue = (value && typeof value === 'string') ? value : ''
	return (
		<Box sx={{ position: 'relative' }} ref={containerRef} className={"form-element "+className}>
			<InputTextElement
				id={name}
				name={name}
				value={displayValue}
				label={label}
				placeholder={placeholder}
				hint={hint}
				error={error}
				invalid={!!error || haserror}
				editing={editing}
				required={required}
				autoFocus={autoFocus}
				disabled={disabled}
				readonly={readonly}
				className={className}
				onChange={onChange}
				slotProps={{
					input: {
						sx: {
							paddingLeft: '42px',
							cursor: readonly || disabled ? 'not-allowed' : 'pointer'
						},
					},
				}}
				onClick={() => {
					if (!readonly && !disabled) setPickerVisible(v => !v)
				}}
			/>
			<Box
				ref={colorButtonRef}
				sx={{
					position: 'absolute',
					top: 34,
					left: 12,
					width: 24,
					height: 24,
					borderRadius: 'sm',
					bgcolor: value || '#FFFFFF',
					border: '1px solid',
					borderColor: 'neutral.outlinedBorder',
					cursor: readonly || disabled ? 'not-allowed' : 'pointer',
					zIndex: 1,
				}}
				onClick={(e) => {
					e.stopPropagation()
					if (!readonly && !disabled) setPickerVisible(v => !v)
				}}
			/>
			{pickerVisible && createPortal(
				<Box
					ref={pickerRef}
					sx={{
						position: 'fixed',
						top: pickerPosition.top,
						left: pickerPosition.left,
						zIndex: 9999,
						'& .chrome-picker': {
							borderRadius: '8px',
							boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
							width: 'auto !important',
							maxWidth: 'none !important'
						}
					}}
				>
					<ChromePicker
						color={value || '#FFFFFF'}
						onChange={(newColor) => onChange?.(newColor.hex)}
						className="chrome-picker"
					/>
				</Box>,
				document.body
			)}
		</Box>
	)
}

export default InputColorPicker